<template lang="pug">
  .main(style="height: 100vh")
    el-row(style="height: 100vh")
      el-col.menu__container(:span="4")
        .menu__block
          el-menu.el-menu-vertical-demo.menu__list(default-active="0")
            router-link(
              v-for="(menu, key) in availableMenus"
              :to="{name: menu.name}"
              :key="`menu-${menu.name}`"
              tag="a")
              el-menu-item(:index="`${key}`")
                i(:class="menu.icon")
                span {{ menu.title }}
            el-menu-item(:index="`${logoutIndex}`" @click="logout")
              i.el-icon-switch-button
              span Выйти
      el-col(:span="20" style="height: 100vh")
        router-view
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { AUTH_LOGOUT } from '../../store/const/user';
  import instruments from '../../mixins/instruments';

  export default {
    name: "Index",
    mixins: [
      instruments,
    ],
    data() {
      return {
        menuList: [
          {
            name: 'ServerInfo',
            title: 'Сервер',
            icon: 'el-icon-monitor',
            access: ['superadmin', 'admin']
          },
         ],
        currentExchange: '',
      }
    },
    async mounted() {},
    computed: {
      ...mapGetters('user', {
        role: 'getRole',
        isAdmin: 'isAdmin',
      }),
      availableMenus() {
        return this.menuList.filter((menu) => menu.access.includes(this.role));
      },
      logoutIndex() {
        return this.availableMenus.length;
      }
    },
    methods: {
      ...mapActions('user', {
        logoutRequest: AUTH_LOGOUT,
      }),
      async logout() {
        await this.logoutRequest();
      },
    }
  }
</script>

<style lang="scss">
	.main {
		text-align: left;
	}

  .menu__list {
    height: 100%;
  }

  .mode-select__container {
    padding: 10px 0;
    margin: auto;
    text-align: center;
    border-bottom: 1px solid #e6e6e6;
  }

  .mode-select__container .title {
    font-weight: 500;
    margin-bottom: 5px;
  }

  .module__main {
    overflow-y: hidden;
    height: calc(100% - 50px);
    display: flex;
    flex-direction: column;
  }

  .module__title {
    font-size: 20px;
    height: 29px;
    padding: 10px;
    background-color: #efefef;
    text-shadow: 1px 1px 1px #cce0f1;
    color: #05447a;
    font-weight: bold;
    text-align: center;
  }

  .module-content__container {
    display: flex;
    flex-direction: column;
    padding: 5px;
    background-color: #e3e0e0;
    border-left: 1px solid #d1cece;
    border-top: 1px solid #d1cece;
    overflow-y: hidden;
    height: 100%;
  }

  .menu__container {
    display: flex;
    height: 100vh;
    flex-direction: column;
    background-color: #efefef;
    padding: 4px;
  }

  .menu__block {
    height: 100%;
  }

  .table__container {
    display: flex;
    flex-direction: column;
    overflow-y: hidden;
  }

  .table-list__container {
    overflow-y: scroll;
    border-radius: 5px;
  }

  .table-pagination__container {
    margin-bottom: 5px;
    text-align: center;
  }

  .table-list__container .val {
    text-overflow: ellipsis;
    word-break: break-word;
  }

  .dialog-add__input {
    width: 100%;
    margin: 5px auto;
  }

  .color-success {
    color: #67C23A;
  }

  .background-success {
    background-color: #67C23A;
  }

  .color-warning {
    color: #E6A23C;
  }

  .background-warning {
    background-color: #E6A23C;
  }

  .color-danger {
    color: #F56C6C;
  }

  .background-danger {
    background-color: #F56C6C;
  }

  .color-info {
    color: #909399;
  }

  .background-info {
    background-color: #909399;
  }

  .color-primary {
    color: #909399;
  }

  .background-primary {
    background-color: #409EFF;
  }

  tr.row-success {
    background-color: #c4f8ae !important;
  }

  tr.row-danger {
    background-color: #fcbbbb !important;
  }

  .balance__container {
    display: flex;
    align-items: center;
    padding: 8px;
    background-color: #efefef;
    font-size: 12px
  }

  .balance-amounts__container {
    margin: auto 10px;
  }

  .balance-amount__container {
    display: flex;
  }

  .balance__icon {
    color: green;
    font-size: 16px;
  }

  .balance__title {
    margin-right: 5px;
    width: 60px;
  }

  .exchange-info__container {
    background-color: #efefef;
    padding: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
  }

  .exchange-info-status {
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }

  .exchange-info-name {
    margin: auto 10px;
    font-weight: bold;
  }

  .exchange-info-wallet {
    margin-left: 10px;
    font-family: monospace;
    font-size: 15px;
    cursor: pointer;
  }

  .exchange-info-status {
    margin: auto 10px;
  }

  .menu__block a {
    text-decoration: none;
  }

  .exchange-select__container {
    width: 250px;
    margin-right: 10px;
  }

  .exchange-select {
    width: 100%;
    margin: auto 5px;
  }
</style>

